/**
 * useChannels - React Query hooks for workspace channels.
 */

import { useQuery } from '@tanstack/react-query'
import {
  getChannels,
  getAllChannelRequirements,
  type Channel,
  type ChannelRequirement,
} from '@/lib/api/channels'

/** Map JTL-channel_id → bevorzugter Anzeigename (custom_name vor channel_name). */
export function useChannelNameLookup(): Record<string, string> {
  const { data } = useQuery({
    queryKey: ['channels', 'name-lookup'],
    queryFn: () => getChannels(true),
    staleTime: 5 * 60 * 1000,
  })
  const map: Record<string, string> = {}
  for (const c of data?.channels ?? []) {
    if (c.channel_id) map[c.channel_id] = c.custom_name || c.channel_name
  }
  return map
}

export function useChannels() {
  return useQuery<Channel[]>({
    queryKey: ['channels'],
    queryFn: async () => {
      const res = await getChannels()
      return res.channels || []
    },
  })
}

export function useAllChannelRequirements() {
  return useQuery<ChannelRequirement[]>({
    queryKey: ['channel-requirements', 'all'],
    queryFn: async () => {
      const res = await getAllChannelRequirements()
      return res.requirements || []
    },
  })
}
